import { useState } from "react";

import { NavLink } from "react-router-dom";

import { CustomInput } from "../../kits/inputs/Input.tsx";
import CustomButton from "../../kits/custom-button/CustomButton.tsx";
import { ArrowRightIcon } from "../../kits/Icons/Icons.tsx";

import UploadImage from "../uploadImage/UploadImage.jsx";

export default function VendorShopInfo() {
  const [shopInfo, setShopInfo] = useState({
    name: "",
    logo: "",
    cover: ""
  });
  function productImageHandler(names, value) {
    setShopInfo(prev => {
      return {
        ...prev,
        [names]: value
      };
    });
  }
  return (
    <div className="">
      <div className="d-flex mr-y-12 pd-x-20 ">
        <NavLink to="/vendor-panel/manager-profile">
          <ArrowRightIcon />
        </NavLink>

        <h6 className="title-h3-b mr-r-8">اطلاعات فروشگاه</h6>
      </div>
      <div className="pd-x-16">
        <div className="mr-t-12">
          <CustomInput
            title="نام فروشگاه"
            placeholder="نام فروشگاه را وارد کنید"
            labelClassName="txt-t2-l pd-b-6"
          />
        </div>
        <div className="mr-t-24">
          <h6 className="txt-t2-l mr-b-12">مکان فروشگاه روی نقشه</h6>
          <CustomButton buttonStyle="secondary" className="w-100">
            انتخاب مکان فروشگاه
          </CustomButton>
        </div>
        <div className="mr-t-24">
          <CustomInput
            title="نشانی"
            placeholder="نشانی را وارد نمایید."
            labelClassName="txt-t2-l pd-b-6"
          />
        </div>
        <div className="mr-t-24">
          <CustomInput
            title="حداقل میزان خرید"
            placeholder="باید حداقل 60,000 تومان باشد"
            labelClassName="txt-t2-l pd-b-6"
          />
        </div>
        <div className="mr-t-24">
          <h6 className="txt-t2-l mr-b-12">لوگو فروشگاه</h6>
          {shopInfo.logo == "" ? (
            <UploadImage
              type="empty"
              productImageHandler={productImageHandler}
              name="logo"
              setShopInfo={setShopInfo}
            />
          ) : (
            <UploadImage
              type="full"
              name="logo"
              setShopInfo={setShopInfo}
              src={URL.createObjectURL(shopInfo.logo)}
            />
          )}
        </div>
        <div className="mr-t-24">
          <h6 className="txt-t2-l mr-b-12">کاور فروشگاه</h6>
          {shopInfo.cover == "" ? (
            <UploadImage
              productImageHandler={productImageHandler}
              type="empty"
              name="cover"
              setShopInfo={setShopInfo}
            />
          ) : (
            <UploadImage
              type="full"
              name="cover"
              setShopInfo={setShopInfo}
              src={URL.createObjectURL(shopInfo.cover)}
            />
          )}
        </div>
        <div className="mr-t-24 mr-b-16">
          <CustomButton className="w-100">ثبت</CustomButton>
        </div>
      </div>
    </div>
  );
}
